import { useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Socket } from 'socket.io-client';
import { ORDER_GET_ONE } from 'api/query-keys';
import type { IOrderInvalidateOneEvent } from './types';
import { ESocketEventName } from './types';

export const useHandleOrderInvalidateOne = (socket: Socket) => {
  const queryClient = useQueryClient();

  const handler = useCallback(
    async (event: IOrderInvalidateOneEvent) => {
      const orderId = event.payload.orderId;

      await queryClient.invalidateQueries([ORDER_GET_ONE, orderId]);
    },
    [queryClient],
  );

  useEffect(() => {
    socket.on(ESocketEventName.orderInvalidateOne, handler);

    return () => {
      socket.removeListener(ESocketEventName.orderInvalidateOne, handler);
    };
  }, [handler, socket]);
};
